import React from 'react';
import './scss/full-screen-loader.scss';
import { Button, Modal } from 'react-bootstrap';
import PasswordDialogProp from './properties/password-dialog';

function PasswordDialog({
  show, onHide, onSubmit, action,
}:PasswordDialogProp): React.ReactElement {
  const [phrase, setPhrase] = React.useState('');
  const onSubmitForm = () => {
    onSubmit(phrase);
    setPhrase('');
  };

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
    >
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title id="contained-modal-title-vcenter">
          <h5 className="text-capitalize">
            Confirm Action:
            {' '}
            {action}
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6>Password Phrase</h6>
        <p>
          This action needs admin privileges, please enter secret phrase here.
        </p>
        <input
          type="password"
          id="password"
          className="form-control p-2 mt-3 "
          value={phrase}
          onChange={(e) => setPhrase(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onSubmitForm}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PasswordDialog;
